import { App } from 'vue';
import projectConfig from '@/project/config';
import search from '@/project/search';

export default async function config(app: App): Promise<void> {
    projectConfig(app);
    search(app);
}
